import { ColorSwatch, IconImage } from 'libs/searchspring/components/collection/filters/FilterCustomisations'
import { FilterCollapse } from 'libs/searchspring/components/collection/filters/FilterCollapse'
import { FilterInputSlider } from 'libs/searchspring/components/collection/filters/FilterSlider'
import { UniversalSizeFilter } from 'libs/searchspring/components/collection/filters/UniversalSizeFilter'
import { useFetchedFilter, useFilterCustomizations, useFilterValues, useActiveFilterLabel } from 'libs/searchspring/components/collection/filters/FilterHooks'

export function FilterItem({ filter, activeFilters, fetchedFilters, onFilter }) {
  if (!filter) return null

  const fetchedFilter = useFetchedFilter(filter, fetchedFilters)
  const filterCustomizations = useFilterCustomizations(filter.field)
  const values = useFilterValues(filter, activeFilters, fetchedFilter, filterCustomizations)
  const activeFilterLabel = useActiveFilterLabel(filter, values, fetchedFilter)

  const FilterContent = () => {
    const isSizeFilter = filter.field === 'ss_instock_sizes' ||
                        filter.field === 'filter.v.option.size' ||
                        filter.field === 'size' ||
                        filter.label?.toLowerCase() === 'size' ||
                        values.some(value => value.label?.includes('|') || value.label?.includes(','))

    if (isSizeFilter) {
      return <UniversalSizeFilter values={values} onFilter={onFilter} />
    }

    switch (filter.type) {
      case 'slider':
        return <FilterInputSlider filter={filter} fetchedFilter={fetchedFilter} onFilter={onFilter} />
      case 'list':
        if (!values.length) return null
        return <FilterInputs field={filter.field} values={values} onFilter={onFilter} />
      default:
        if (!values.length) return null
        return <FilterInputs field={filter.field} values={values} onFilter={onFilter} />
    }
  }

  return (
    <FilterCollapse label={filter.label} activeFilterLabel={activeFilterLabel}>
      <div className="flex flex-col gap-y-1.5 px-1 md:px-1.5 pt-0.75 pb-1.875">
        {FilterContent()}
      </div>
    </FilterCollapse>
  )
}

const FilterInputs = ({ values, onFilter, field }) => {
  return (
    <>
    {values.map((item) => {
      return (
        <div className="group/filter-item flex items-center justify-between cursor-pointer" key={item.value}>
          <input
            id={item.value}
            className={`shrink-0 field-checkbox peer disabled:pointer-events-none disabled:cursor-not-allowed group-hover/filter-item:bg-primary group-hover/filter-item:border-primary ${
              item.color || item.icon ? 'size-0 opacity-0 invisible pointer-events-none overflow-hidden' : 'disabled:opacity-50 mr-0.5'
            }`}
            type="checkbox"
            name={field}
            checked={item.checked}
            disabled={item.disabled}
            onClick={() => onFilter(item.value)}
            aria-label={item.label}
          />
          <label
            for={item.value}
            className="grow flex items-center paragraph-b whitespace-nowrap cursor-pointer peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-disabled:cursor-not-allowed overflow-hidden text-ellipsis"
          >
            {item.color && <ColorSwatch color={item.color} />}
            {item.icon && <IconImage iconObject={item.icon} />}
            {item.label}
            <span className="paragraph-b text-neutral-secondary">
              &nbsp;({item.count ?? 0})
            </span>
          </label>
        </div>
      )
    })}
    </>
  )
}
